export default __webpack_public_path__ + "static/media/PFSquareSansProThinItalic_35491.6413cc89.ttf";